import React from 'react';
import InlineTextField from "../../components/InlineTextField";

class ModuleItemDeactivator extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isEditing: false,
            deactivationReason: ''
        };

        this.edit = this.edit.bind(this);
        this.cancel = this.cancel.bind(this);
        this.commit = this.commit.bind(this);
        this.updateReason = this.updateReason.bind(this);
        this.validate = this.validate.bind(this);
    }

    edit() {
        this.setState({isEditing: true})
    }

    cancel() {
        this.setState({isEditing: false});
    }

    commit() {
        this.props.deactivateModuleItem(this.props.moduleName, this.props.gtin, this.state.deactivationReason);
        this.setState({isEditing: false});
    }

    updateReason(event) {
        this.setState({deactivationReason: event.target.value});
    }

    validate() {
        const deacReason = this.state.deactivationReason;
        return (deacReason.length !== 0 && deacReason.trim());
    }

    render() {
        if (this.state.isEditing) {
            return (
                <div>
                    <div className="input-group">
                        <input type="text"
                               value={this.state.deactivationReason}
                               placeholder='Ausverkauft, Produktfehler, ...'
                               name="deactivationReason"
                               className="form-control"
                               onChange={this.updateReason}/>
                        <div className="input-group-btn">
                            <button className="btn btn-success" onClick={this.commit} disabled={!this.validate()}>
                                <i className="fa fa-check"/>&nbsp;
                            </button>
                            <button className="btn btn-secondary" onClick={this.cancel}>
                                <i className="fa fa-times"/>&nbsp;
                            </button>
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <div>
                <label className="switch switch-text switch-success form-control-label">
                    <input onClick={this.edit} type="checkbox" className="switch-input form-check-input" value="on" defaultChecked={true}/>
                    <span className="switch-label" data-on="On" data-off="Off"/>
                    <span className="switch-handle"/>
                </label>
            </div>
        );
    }
}

export default ModuleItemDeactivator;



// WEBPACK FOOTER //
// ./src/admin/module/overview/ModuleItemDeactivator.js